import React, { useState, useEffect } from 'react';
import { Label } from "./label";
import { Checkbox } from "./checkbox";
import { Input } from "./input";
import { Button } from "./button";
import { Undo2 } from "lucide-react";

const FilterSection = ({ showTopographyOnly, setShowTopographyOnly, kmRange, setKmRange, kmRangeExtents }) => {
  const [minInput, setMinInput] = useState(kmRange[0].toString());
  const [maxInput, setMaxInput] = useState(kmRange[1].toString());

  useEffect(() => {
    setMinInput(kmRange[0].toString());
    setMaxInput(kmRange[1].toString());
  }, [kmRange]);

  const handleInputChange = (value, isMin) => {
    const numValue = parseInt(value) || 0;
    if (isMin) {
      if (numValue <= kmRange[1] && numValue >= kmRangeExtents.min) {
        setKmRange([numValue, kmRange[1]]);
      }
    } else {
      if (numValue >= kmRange[0] && numValue <= kmRangeExtents.max) {
        setKmRange([kmRange[0], numValue]);
      }
    }
  };

  const handleReset = () => {
    setShowTopographyOnly(false);
    setKmRange([0, kmRangeExtents.max]);
    setMinInput(0);
    setMaxInput(kmRangeExtents.max.toString());
  };

  return (
    <div className="space-y-6 py-4">
      <div className="flex items-center justify-between">
        <Button 
          variant="default" 
          size="sm" 
          onClick={handleReset}
          className="w-full"
        >
          <Undo2 className="h-4 w-4 mr-2" />
          Show All
        </Button>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox 
          id="topography-filter"
          checked={showTopographyOnly}
          onCheckedChange={setShowTopographyOnly}
          className="h-5 w-5 border-2 rounded-xl"
        />
        <Label 
          htmlFor="topography-filter" 
          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          Show only with topography
        </Label>
      </div>
      
      <div className="space-y-4">
        <Label className="text-sm font-medium">Area Range (km²)</Label>
        <div className="flex items-center gap-4">
          <div className="flex-1 bg-gray-200 rounded-xl">
            <Input
              type="number"
              value={minInput}
              onChange={(e) => {
                setMinInput(e.target.value);
                handleInputChange(e.target.value, true);
              }}
              min={0}
              max={kmRange[1]}
              className="w-full border-0 rounded-xl"
              placeholder="Min"
            />
          </div>
          <span className="text-sm text-muted-foreground">to</span>
          <div className="flex-1 bg-gray-200 rounded-xl">
            <Input
              type="number"
              value={maxInput}
              onChange={(e) => {
                setMaxInput(e.target.value);
                handleInputChange(e.target.value, false);
              }}
              min={kmRange[0]}
              max={kmRangeExtents.max}
              className="w-full border-0 rounded-xl"
              placeholder="Max"
            />
          </div>
        </div>
        <div className="flex justify-between text-xs text-muted-foreground">
          <span>Min: 0 km²</span>
          <span>Max: {kmRangeExtents.max} km²</span>
        </div>
      </div>
    </div>
  );
};

export default FilterSection;